import React from 'react';
import { FaLongArrowAltUp } from 'react-icons/fa';
import { FaLongArrowAltDown } from 'react-icons/fa';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      asc: false,
      sortCol: { name: '', asc: false },
    };
  }

  changeSortDir = (label, customSort) => {
    const { sortCol } = this.state
    if (sortCol.name !== label) { sortCol.asc = false; sortCol.name = '' }
    this.setState(prevState => {
      let sortCol = Object.assign({}, prevState.sortCol);
      sortCol.name = label;
      sortCol.asc = !sortCol.asc
      return { sortCol };
    }, () => {
      this.props.getDataOnSort(!sortCol.asc, customSort ? customSort : label)
    })
  }

  render() {
    const { sortCol } = this.state;
    const { col, searchClassName, headingClassName, headerColumnClsName, colData, headerCol } = this.props;
    const newClassName = searchClassName ? `headerAddOns ${searchClassName}` : `headerAddOns`;
    const newHeaderColumnClsName = headerColumnClsName ? `headerColumn ${headerColumnClsName}` : `headerColumn`;
    const newColHeader = headerCol ? `column-header ${headerCol}` : `column-header`;
    const { sortable, label, customColumn, customSort } = col;
    return (
      <div className={newColHeader}>
        <div className={newHeaderColumnClsName}>
          <h6 className={headingClassName}>
            {sortable ? (<a href="true" style={{ cursor: 'pointer', color: 'black', textDecoration: 'none' }}
              onClick={(e) => {
                e.preventDefault();
                this.changeSortDir(col.dataKey, customSort)
              }}>
              {label}{(sortCol.name === col.dataKey) ? (sortCol.asc ? <FaLongArrowAltUp /> : <FaLongArrowAltDown />) : ''}</a>) : label}
          </h6>
        </div>
        {(customColumn) && (
          <div className={newClassName}>
            {customColumn
              ? customColumn({
                col,
                colData
              })
              : null}
          </div>
        )}
      </div>
    );
  }
}


export default App;
